import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { DxModule } from '../../../shared/dx.module';
import { MaterialModule } from '../../../shared/material.module';
import { EmailTemplatesModule } from '../../../shared/email-templates/email-templates.module';
import { DefaultEmailTemplatesComponent } from './default-email-templates/default-email-templates.component';

export const defaultEmailTemplatesRoutes: Route[] = [
  {
    path: '',
    component: DefaultEmailTemplatesComponent
  }
];

@NgModule({
  declarations: [DefaultEmailTemplatesComponent],
  imports: [
    SharedModule,
    MaterialModule,
    DxModule,
    EmailTemplatesModule,
    RouterModule.forChild(defaultEmailTemplatesRoutes)
  ]
})
export class DefaultEmailTemplatesModule { }
